import GenericPage from '../components/generic/GenericPage'
import tiles from '../components/generic/Tiles'

const MapRN = () => {
  return (
    <GenericPage frame="https://rsgiskaznu.maps.arcgis.com/apps/mapviewer/index.html?webmap=2cdb5920eb474456ac5e96913fcb87fe" title="Карта сельскохозяйственной освоенности природных комплексов" tiles={tiles.back('map')} frame_offset={60}/>
  )
}
export default MapRN
